import { useSelector } from 'react-redux'
import { selectAccountApiKey, selectLicensingLimits } from '@/features/domain/user'

export function useApiKey() {
  const apiKey = useSelector(selectAccountApiKey)
  const { allowApi, allowSimulationApi } = useSelector(selectLicensingLimits)

  const apiKeyEnabled = allowApi || allowSimulationApi

  return { apiKey, apiKeyEnabled }
}
